import React from 'react';
import 'moment/locale/es';
import { getEventColor, getEventPillLabel } from './calendarEventTypes';

/**
 * Componente que renderiza un evento individual en el calendario
 *
 * Muestra una etiqueta corta con color según el tipo de evento.
 * Al hacer click, navega a la entidad relacionada.
 *
 * @param {Object} event - Objeto evento con type, title, link, etc.
 * @param {Function} onClick - Callback cuando se hace click en el evento
 * @param {boolean} compact - Si es true, siempre muestra la etiqueta corta del tipo (para usar junto al título, como en el modal de día)
 */
function CalendarEvent({ event, onClick, compact = false }) {
	const color = getEventColor(event.type);
	// Los eventos de Google no tienen una etiqueta de tipo útil ("Google" para todos) —
	// mostrar el título real del evento en su lugar, salvo en vistas compactas donde el título ya se muestra aparte
	const label = (!compact && event.type === 'google-event') ? event.title : getEventPillLabel(event.type);

	return (
		<div
			className='calendar-event'
			style={{ backgroundColor: color }}
			onClick={onClick}
			title={event.title}
		>
			{label}
		</div>
	);
}

export default CalendarEvent;

